import script from "./StatusAtual.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusAtual.vue?vue&type=script&setup=true&lang=js"

import "./StatusAtual.vue?vue&type=style&index=0&id=e29993d4&lang=css"

const __exports__ = script;

export default __exports__